<footer>
<div class="container-fluid grid">
  <div class="row footer m-0 p-0 pt-5 pb-5">
    <div class="col-xl-1"></div>
    <div class="col-xl-3 text-center text-xl-start">
      <img src="../../../assets/img/logo_bn.png" alt="logo" />
    </div>
    <div
      class="col-xl-2 mt-4 mt-xl-0 d-flex justify-content-center justify-content-xl-start text-center text-xl-start"
    >
      <ul>
        <li class="mt-2">
          <a href="/chi-siamo" class="footer-link">Chi siamo</a>
        </li>
        <li class="mt-2">
          <a href="/corsi-coding" class="footer-link">I corsi</a>
        </li>
        <li class="mt-2">
          <a href="/didattica-digitale-per-scuole" class="footer-link"
            >Il progetto</a
          >
        </li>
        <li class="mt-2">
          <a href="/piattaforma-di-apprendimento" class="footer-link"
            >La piattaforma</a
          >
        </li>
      </ul>
    </div>
    <div
      class="col-xl-3 d-flex justify-content-center justify-content-xl-start text-center text-xl-start"
    >
      <ul class="footer-link">
        <li class="mt-3">
          <a
            href="mailto:info@easycode.org"
            class="text-decoration-none text-reset"
          >
            <img
              src="../../../assets/img/Mail.png"
              class="icon-footer"
              alt="mail"
             
            />info@easycode.org</a
          >
        </li>
        <li class="mt-3">
          <a href="tel:+393407245340" class="text-decoration-none text-reset">
            <img
              src="../../../assets/img/Phone.png"
              class="icon-footer"
              alt="phone"
             
            />+39 340 72 45 340</a
          >
        </li>
        <li class="mt-3">
          <a
            href="https://goo.gl/maps/SMfHbXb6hUmntzaQA"
            class="text-decoration-none text-reset"
            target="_blank"
            ><img
              src="../../../assets/img/Location.png"
              class="icon-footer"
              alt="location Milano"
             
            />Viale Elvezia 18, 20154 Milano</a
          >
        </li>
      </ul>
    </div>
    <div
      class="col-xl-2 d-flex justify-content-center align-items-center justify-content-xl-end mt-3 mt-xl-0"
    >
      <a
        href="https://www.facebook.com/EasyCode-112935417547656"
        target="_blank"
        ><img
          src="../../../assets/img/facebook.png"
          class="social p-2"
          alt="social"
         
      /></a>

      <a href="https://www.instagram.com/easycode_edu/" target="_blank"
        ><img
          src="../../../assets/img/instagram.png"
          class="social p-2"
          alt="social"
         
      /></a>

      <a href="https://www.tiktok.com/@easycode_edu" target="_blank"
        ><img
          src="../../../assets/img/tiktok.png"
          class="social p-2"
          alt="social"
         
      /></a>

      <a
        href="https://www.linkedin.com/company/easycodelearningthefuture/"
        target="_blank"
        ><img
          src="../../../assets/img/linkedin.png"
          class="social p-2"
          alt="social"
         
      /></a>
    </div>
    <div class="col-xl-1"></div>
  </div>

  <!--  -->
  <div class="container-fluid grid text-center text-xl-start">
    <div class="row footer-details m-0 p-0 mb-5">
      <div class="col-xl-1"></div>
      <div class="col-xl-4 d-flex flex-column flex-xl-row">
        <a
          href="assets/docs/easycode_Luna_Labs_Privacy_Policy_Website.pdf"
          class="text-reset text-decoration-none"
          target="_blank"
          ><span class="ft-details my-2 my-xl-0">Privacy Policy</span></a
        >

        <a
          href="https://www.iubenda.com/privacy-policy/89506479/cookie-policy"
          class="text-reset text-decoration-none"
          target="_blank"
          ><span class="ft-details my-2 my-xl-0">Cookie Policy</span></a
        >
        <a
          href=" https://policies.google.com/terms"
          class="text-reset text-decoration-none"
         
          target="_blank"
          ><span class="ft-details my-2 my-xl-0">Termini e Condizioni</span></a
        >
      </div>

      <div class="col-xl-6 text-center text-xl-end mt-4 mt-xl-0">
        <span class="copyrights">
          ©{{ currentYear }} by Luna Labs srl Unipersonale. All rights reserved
        </span>
      </div>
      <div class="col-xl-1"></div>
    </div>
  </div>
</div>
</footer>
